import authService from "./authService";
import SecureCookieManager from '../utils/secureCookie';

const BASE_URL = process.env.REACT_APP_API_URL;


function getToken() {
    return SecureCookieManager.getAuthToken();
}

export async function createCategory(data: any) {
    try {
        const response = await authService.apiCall(`${BASE_URL}/question-categories`, {
            method: 'POST',
          
    body: JSON.stringify(data)

        });
        if (!response.ok) {
            throw new Error('Failed to create Category');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error creating Category:', error);
        throw new Error('Error creating Category');
    }
}

export async function getCategory() {
  try {
    const response = await authService.apiCall(`${BASE_URL}/question-categories/all`, {
      method: 'GET',
    
    });

    if (!response.ok) {
      throw new Error('Failed to get category');
    }

    const result = await response.json();
    //console.log('category fetched successfully:', result);
    return result;
  } catch (error) {
    console.error('Error fetching category:', error);
    throw error;
  }
}

export async function getCategoriesPaged(query: string = "", perPage: number = 10, pageNo: number = 0) {
  try {
    const params = new URLSearchParams();
    if (query) params.set('query', query);
    params.set('perPage', String(perPage));
    params.set('pageNo', String(pageNo));

    const response = await authService.apiCall(`${BASE_URL}/question-categories?${params.toString()}`, {
      method: 'GET',
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result?.message || 'Failed to get categories');
    }

    return result; // { data, totalPages, totalCount }
  } catch (error) {
    console.error('Error fetching categories (paged):', error);
    throw error;
  }
}